import Vue from 'vue'
import Vuex from 'vuex'
import { jwtDecode } from 'jwt-decode'

// Modules Adm
import Employees from './modules/funcionarios'
import Empresas from './modules/empresas'
import Equipamentos from './modules/equipamentos'
import Estatisticas from './modules/estatisticas'
import Analises from './modules/analises'
import Melhorias from './modules/melhorias'
import { DB_ROLES, normalizeRole } from '../constants'
import home from './modules/home'

Vue.use(Vuex)

const roleFromState = (state) => {
  const stored = normalizeRole(state.user?.userRole || state.user?.UserRole)
  if (stored) return stored

  try {
    const token = state.token || sessionStorage.token
    if (!token) return ''
    const decoded = jwtDecode(token)
    return normalizeRole(
      decoded.role ||
      decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] ||
      decoded.UserRole ||
      decoded.userRole
    )
  } catch (error) {
    return ''
  }
}

export default new Vuex.Store({
  state: {
    user: JSON.parse(sessionStorage.user || '{}'),
    token: sessionStorage.token || undefined,
    dashboard: ['home', 'analises', 'melhorias', 'funcionarios', 'empresas', 'equipamentos', 'estatisticas']
  },
  getters: {
    isLogged: state => Object.keys(state.user).length !== 0 && state.token !== undefined,
    isSuperAdmin: state => roleFromState(state) === DB_ROLES.SUPER_ADMIN,
    isManager: state => roleFromState(state) === DB_ROLES.MANAGER,
    isOperator: state => roleFromState(state) === DB_ROLES.OPERATOR,
    isReadOnly: state => roleFromState(state) === DB_ROLES.COMMON,
    userRole: state => roleFromState(state)
  },
  mutations: {
    login: (state, payload) => {
      state.user = payload.user
      state.token = payload.token
    },
    logout: state => {
      state.user = {}
      state.token = undefined
    }
  },
  actions: {
    login: (context, payload) => {
      sessionStorage.user = JSON.stringify(payload.user)
      sessionStorage.token = payload.token
      context.commit('login', payload)
    },
    logout: context => {
      sessionStorage.clear()
      context.commit('logout')
    }
  },
  // Adicionar o modulo com seus respectivos nomes que sera importado no menu lateral
  modules: {
    funcionarios: Employees,
    empresas: Empresas,
    equipamentos: Equipamentos,
    estatisticas: Estatisticas,
    analises: Analises,
    melhorias: Melhorias,
    home
  }
})
